// История рейса: /api/v2/trip-history/{id} (erp-backend, модуль src/trip_history).
import { useAxiosCreate } from '@/backend/utils.js'

const api = useAxiosCreate('api')

export async function fetchTripHistory(tripId) {
  const { data } = await api.get('trip-history/' + encodeURIComponent(tripId))
  return data
}
